import React, { Component } from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  children: PropTypes.any,
  fallbackComponent: PropTypes.any,
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
    }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  render() {
    const { hasError, error } = this.state
    const { children, fallbackComponent: FallbackComponent = React.Fragment } =
      this.props
    const props = this.props
    if (hasError) {
      return <FallbackComponent error={error} {...props} />
    }
    return children
  }
}

ErrorBoundary.propTypes = propTypes

export default ErrorBoundary
